import { IRectangle, List } from '@fluentui/react';
import { OrderModel, OrderStatus } from '../../models/OrderModel';
import OrderItemCompactView from './OrderItemCompactView';
import RequestedOrderItemView from './RequestedOrderItemView';

type OrderGridProps = {
    orders: OrderModel[];
    onDetail: (order: OrderModel) => void;
    onDelete: (order: OrderModel) => void;
    onInvoiceDetail: (id: string) => void;
}

export default function OrderGridView({ orders, onDetail, onDelete, onInvoiceDetail }: OrderGridProps) {
    var columnCount: number = 0;

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0) {
            if (surfaceRect != null && surfaceRect.width < 700) columnCount = 1;
            else if (surfaceRect != null && surfaceRect.width < 1050) columnCount = 2;
            else columnCount = 3;
        }

        return orders.length;
    }

    const onRenderCell = (order?: OrderModel, index?: number, isScrolling?: boolean) => {
        const width = (100 / columnCount) + '%';
        const hPadding = columnCount === 1 ? " ph-10" : "";
        const vPadding = columnCount === 1 ? " pv-10" : " pv-20";

        if (order == null) return <>empty</>;

        return <div
            key={order.id + "-wrapper"}
            className={"list-grid-tile" + vPadding + hPadding}
            style={{ width: width, height: "auto" }}
            data-is-focusable={true}
        >
            {order.status !== OrderStatus.request && <>
                <OrderItemCompactView
                    key={order.id}
                    order={order}
                    onDetail={onDetail}
                    onInvoiceDetail={onInvoiceDetail}
                />
            </>}

            {order.status === OrderStatus.request && <>
                <RequestedOrderItemView
                    key={order.id}
                    order={order}
                    onDetail={onDetail}
                    onDelete={onDelete}
                />
            </>}
        </div>;
    }

    return <div style={{ marginLeft: -20, marginRight: -20 }}>
        <List
            items={orders}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage}
        />
    </div>;
}